import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomListaFacturas
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0009.7
 **/
class CustomListaFacturas extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm                                           = this.initForm.bind(this);

        // Variables de tablas:
        this.gridOptionsTablafacturas                            = Object.assign({}, this.gridOptions);
        this.gridOptionsTablaItems                                 = Object.assign({}, this.gridOptions);
        this.gridOptionsTablafacturas["onSelectionChanged"]      = this.onSelectionChangedTb;
        this.gridOptionsTablaItems["onSelectionChanged"]           = this.onSelectionChangedTb;
        // Funciones:
        this.consultaFactura                                      = this.consultaFactura.bind(this);
        this.successTablaConsultar                                 = this.successTablaConsultar.bind(this);
        this.habilitarBotonConsultar                               = this.habilitarBotonConsultar.bind(this);
        this.crearBotones                                          = this.crearBotones.bind(this);
        this.crearBotonTabla                                       = this.crearBotonTabla.bind(this);
        this.isJson                                                = this.isJson.bind(this);
        this.generarPdf                                            = this.generarPdf.bind(this);
        this.procesar                                              = this.procesar.bind(this);
        this.mostrarMensajeNoHayDatos                              = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeEmailFallo                              = this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                            = this.mostrarMensajeEmailEnviado.bind(this);
        this.mostrarMensajeAdicional                               = this.mostrarMensajeAdicional.bind(this);
        this.todas=false;
        this.validaciones                                          = this.validaciones.bind(this);
        this.validarNit                                            = this.validarNit.bind(this);
        this.validarfechas                                         = this.validarfechas.bind(this);
        this.accionBoton                                           = this.accionBoton.bind(this);
        this.TraerItems                                            = this.TraerItems.bind(this);
        this.successTraerItems                                     = this.successTraerItems.bind(this);
        this.cantidadtablaChange                                   = this.cantidadtablaChange.bind(this);
        this.validarestado                                         = this.validarestado.bind(this);
        this.successValidarEstado                                  = this.successValidarEstado.bind(this);
        this.GuardarDevolucion                                     = this.GuardarDevolucion.bind(this);
        this.successGrabarDevolucion                               = this.successGrabarDevolucion.bind(this);
        this.columna_modificada = "";
        this.filterTextLoweCase = "";

        this.onBtNext2                                             = this.onBtNext2.bind(this);
        this.onBtPrevius2                                          = this.onBtPrevius2.bind(this);
        this.onKeyUpText                                           = this.onKeyUpText.bind(this);
        this.currencyFormatterGeneral                              = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo                                     = this.formatNumberSaldo.bind(this);
        this.countTotal=0;
        this.filtrosTabla = {};
        this.columna = "";
        this.orden = ""; 

        //tarea/13621
        this.successTraerDatosBodegas                              = this.successTraerDatosBodegas.bind(this);
        this.traerDatosBodegas                                     = this.traerDatosBodegas.bind(this);

    }

    initForm() {
        console.log("Formulario CustomListaFacturas,  @version: jdesk_1.01.0009.13, @author: Patricia Lopez Sanchez, @Fecha creación: 20/11/2025, @Modificado Por: Anderson Acevedo,@Fecha Modificación: 03/07/2026");
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;

        this.getField('facturas').setOnBtnNext(this.onBtNext2);
        this.getField('facturas').setOnBtnPrevius(this.onBtPrevius2);
        this.getField('facturas').setKeyUpText(this.onKeyUpText)

        this.getField('consultar').setClick(this.validaciones);
        this.getField('fecha_desde').setOnChange(this.validarfechas);
        this.getField('fecha_hasta').setOnChange(this.validarfechas);
        this.getField("nit").setCustomSuccess(this.validarNit);
        this.getField('numero').setOnChange(this.habilitarBotonConsultar);
        this.getField('nit').setOnChange(this.habilitarBotonConsultar);
        this.getField('generar_archivo').setClick(() => this.procesar());
        this.getField('guardar_devolucion').setClick(() => this.GuardarDevolucion());
        this.getField('cancelar').setClick(() => {
            this.getField('modal_items').handleClose();
            this.getField("items").toggle(false);
            this.gridOptionsTablaItems["rowData"] = [];
            this.datos_item = [];
        });

        this.getField('radio_correo').setOnChange((props) => {
            if (this.getField('radio_correo').getValue() === 'N') {
                this.getField('email').setDisabled(true);
                this.getField('email').setValue('');
                this.getField('email').setError(false, '');
            } else {
                this.getField('email').setDisabled(false);
                this.getField('email').setValue('');
                this.getField('email').setError(false, '');
            }
        });

        //tarea/13621
        this.traerDatosBodegas();
    }

    onSelectionChangedTb(){

    }

    habilitarBotonConsultar() {
        this.getField('facturas').toggle(false);
        this.getField('consultar').setDisabled(false);
        this.getField('fecha_desde').setError(false, '');
        this.getField('numero').setError(false, '');
        this.getField('sede').setError(false, '');
    }

    validarfechas() {

        this.getField('consultar').setDisabled(false);
        let fecha_desde = new Date(this.getField("fecha_desde").getValue()).toISOString().split('T')[0];
        let fecha_hasta = new Date(this.getField("fecha_hasta").getValue()).toISOString().split('T')[0];
        this.habilitarBotonConsultar();

        this.getField("fecha_desde").setError(false, "");

        if (fecha_desde > fecha_hasta) {
            this.getField("fecha_desde").setError(true, "No puede ser mayor a la fecha hasta.");
            this.getField('consultar').setDisabled(true);
        }
    }

    validaciones() {

        this.columna_modificada = "";
        this.filterTextLoweCase = "";
        this.filtrosTabla = {};
        this.countTotal = 0;
        this.columna = "";
        this.orden= "";
        this.getField('facturas').countPagination = 1;

        if(this.getField('numero').getValue() !== '' || this.getField('nit').getValue() !== ''){
            if (this.getField('sede').getValue() !== '' ||
                this.getField('numero').getValue() !== '') {
                this.seguir = true;
            }
    
            if (this.getField('nit').getValue() !== '' && this.getField('sede').getValue() === '') {
                this.seguir = false;
                this.getField('sede').setError(true, '*Este campo es requerido');
            }
    
            if (this.seguir) {
    
                if(this.getField('nit').getValue() !== '' && this.sedes > 1){
                    this.getField('confirmModalCustom').setTitleAndContent('Consulta', '¿Desea ver todas las sedes del NIT o solo la seleccionada?')
                    this.getField('confirmModalCustom').setClickDialog(() => {                 
                        this.todas=true;
                        this.getField('confirmModalCustom').toggle(false);
                        this.consultaFactura();
                    });
                    this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                        this.todas=false;
                        this.getField('confirmModalCustom').toggle(false);
                        this.consultaFactura();
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(false);// Para mostrar el Cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm('SI'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField("confirmModalCustom").setButtonCancel('NO');
                    this.getField('confirmModalCustom').toggle(true);
                }else{
                    this.consultaFactura();
                }
            }
        }else{
            this.consultaFactura();
        }
    }

    consultaFactura() {
        let datos={ datos: { } };

        datos.datos={};

        if(Object.keys(this.filtrosTabla).length > 0){
            for (let key in this.filtrosTabla) {
                if (this.filtrosTabla.hasOwnProperty(key)) {
                    let filtro = this.filtrosTabla[key];
    
                    // Verificamos qué campo es y tomamos el valor del filtro
                    if (key.includes('numero')) {
                        datos.datos.numero = filtro.filter;
                        datos.datos.columna1 = "numero"
                    }else{
                        if(this.getField('numero').getValue() !== ''){
                            datos.datos.numero=this.getField('numero').getValue();
                        }else{
                            this.getField('numero').setError(false,'');
                        }
                    }

                    if (key.includes('nit')) {
                        datos.datos.nit = filtro.filter;
                        datos.datos.columna2 = "nit"
                    } else{
                        if(this.getField('nit').getValue() !== '' && this.getField('sede').getValue() !== ''){
                            datos.datos.nit=this.getField('nit').getValue();
                        }else{
                            this.getField('nit').setError(false,'');
                        }
                    }

                    if (key.includes('fecha')) {
                        datos.datos.fecha = filtro.dateFrom || filtro.filter;
                        datos.datos.columna3 = "fecha"
                    } else{

                        if(this.getField('fecha_desde').getValue() !== '' || this.getField('fecha_hasta').getValue() !== ''){
                            datos.datos.fecha_desde =this.getField('fecha_desde').getValue();
                            datos.datos.fecha_hasta =this.getField('fecha_hasta').getValue();
                        }else{
                            this.getField('fecha_desde').setError(false,'');
                            this.getField('fecha_hasta').setError(false,'');
                        }
                    }

                    if (key.includes('pedido')) {
                        datos.datos.pedido = filtro.filter;
                        datos.datos.columna4 = "pedido"
                    }

                    if (key.includes('codigo_sucursal')) {
                        datos.datos.codigo_sucursal = filtro.filter;
                        datos.datos.columna5 = "codigo_sucursal"
                    }
                }
            }
        }else{
            if(this.getField('numero').getValue() !== ''){
                datos.datos.numero=this.getField('numero').getValue();
            }else{
                this.getField('numero').setError(false,'');
            }
            if(this.getField('fecha_desde').getValue() !== '' || this.getField('fecha_hasta').getValue() !== ''){
                datos.datos.fecha_desde =this.getField('fecha_desde').getValue();
                datos.datos.fecha_hasta =this.getField('fecha_hasta').getValue();
            }else{
                this.getField('fecha_desde').setError(false,'');
                this.getField('fecha_hasta').setError(false,'');
            }
            if(this.getField('nit').getValue() !== ''){
                datos.datos.nit=this.getField('nit').getValue();
            }else{
                this.getField('nit').setError(false,'');
            }
            if(this.getField('sede').getValue() !== '' && !this.todas){
                datos.datos.sede=this.getField('sede').getValue();
            }else{
                this.getField('sede').setError(false,'');
            }
        }

        if(this.columna !== "" && this.orden !== null){
            datos.datos.columna=this.columna;
            datos.datos.orden=this.orden;
        }


        datos.datos.sql_filter="OFFSET "+(this.countTotal*15)+" LIMIT 15";

        this.generalFormatPmv = { tipo_servicio: 'fact-listafacturas', operacion: 'traer_factura', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successTablaConsultar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false
            });

    }

    successTablaConsultar(data) { 
        if (data.estado_p === 200) {
            this.getField('consultar').setDisabled(true);
            this.getField("facturas").disabledButtons(false);

            if (data.data.data.length >= 1) {

                const textFilterParams = {
                    filterOptions: ['contains'],
                    buttons: ['apply'],
                    suppressAndOrCondition: true,
                    closeOnApply: true,
                    textFormatter: (text) => (text || '').toString().toLowerCase(),
                    debounceMs: 200,
                    maxNumConditions: 1,
                };

                let configCell = new Map();

                configCell.set('accion', {cellRenderer: this.crearBotones, sortable: false, filter: false, field: 'Acción', width: 240});

                configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"}});
                
                configCell.set('sede', {cellStyle: {textAlign:"right"}});

                configCell.set("numero", {
                    filter: "agTextColumnFilter",
                    filterParams: textFilterParams,
                    valueGetter: (p) => (p.data?.numero != null ? String(p.data.numero) : "")
                });

                configCell.set("codigo_sucursal", {
                    filter: "agTextColumnFilter",
                    filterParams: textFilterParams,
                    valueGetter: (p) => (p.data?.codigo_sucursal != null ? String(p.data.codigo_sucursal) : "")
                });

                configCell.set("pedido", {
                    filter: "agTextColumnFilter",
                    filterParams: textFilterParams,
                    valueGetter: (p) => (p.data?.pedido != null ? Number(p.data.pedido) : "")
                });

                configCell.set("nit", {
                    filter: "agTextColumnFilter",
                    filterParams: textFilterParams,
                    valueGetter: (p) => (p.data?.nit != null ? String(p.data.nit) : "")
                });

                configCell.set("fecha", {
                    filter: "agDateColumnFilter",
                    filterParams: {
                        filterOptions: ['contains'],
                        buttons: ['apply'],
                        suppressAndOrCondition: true,
                        closeOnApply: true,
                        debounceMs: 200,
                        maxNumConditions: 1,
                        comparator: (filterDate, cellValue) => {
                            if (!cellValue) return 0;
                            const cellDate = new Date(cellValue);
                            const celDay = cellDate.getDate();
                            const celMonth = cellDate.getMonth();
                            const celYear = cellDate.getFullYear();

                            if (celYear < filterDate.getFullYear()) return -1;
                            if (celYear > filterDate.getFullYear()) return 1;
                            if (celMonth < filterDate.getMonth()) return -1;
                            if (celMonth > filterDate.getMonth()) return 1;
                            if (celDay < filterDate.getDate()) return -1;
                            if (celDay > filterDate.getDate()) return 1;
                            return 0;
                        }
                    },
                    valueGetter: (p) => p.data?.fecha || ""
                });

                this.gridOptionsTablafacturas.onFilterChanged = (event) => {
                    const api = event.api;
                    const filterModel = api.getFilterModel();

                    this.filtrosTabla = filterModel;
                    const colIds = Object.keys(filterModel);

                    if (colIds.length > 0 || this.filtrosTabla.length > 0) {
                        const ultimaColumna = colIds[colIds.length - 1];
                        let valorFiltro = filterModel[ultimaColumna]?.filter || filterModel[ultimaColumna]?.dateFrom || "";

                        if (valorFiltro instanceof Date) {
                            const fecha = new Date(valorFiltro);
                            valorFiltro = `${String(fecha.getDate()).padStart(2,"0")}/${String(fecha.getMonth()+1).padStart(2,"0")}/${fecha.getFullYear()}`;
                        } else {
                            valorFiltro = (valorFiltro || "").toString().trim();
                        }

                        if (this.columna_modificada !== ultimaColumna || this.filterTextLoweCase !== valorFiltro) { 
                            this.getField('facturas').countPagination = 1;
                            this.countTotal = 0; 
                        }

                        this.columna_modificada = ultimaColumna;
                        this.filterTextLoweCase = valorFiltro;

                        this.consultaFactura();
                    } else {
                        // No hay filtros activos
                        this.columna_modificada = "";
                        this.filterTextLoweCase = "";
                        this.countTotal = 0; 
                        this.columna = "";
                        this.orden= "";
                        this.getField('facturas').countPagination = 1;
                        this.consultaFactura();
                    }
                };

                this.gridOptionsTablafacturas.onSortChanged = (event) => {
                    let tamaño = event.columns.length;
                    this.columna = event.columns[tamaño-1].colId
                    this.orden = event.columns[tamaño-1].sort

                    if(this.orden !== null){
                        this.countTotal = 0; 
                        this.consultaFactura();
                    }else{
                        this.columna = "";
                        this.orden= "";
                        this.consultaFactura();
                    }
                }

                this.gridOptionsTablafacturas.enableCellTextSelection = true;
    
                let totalregistros = data.data.data.length > 0 ? data.data.data[0].full_count : 0;
                this.getField('facturas').setTtotalPg(Math.ceil(totalregistros / 15));

                if(Math.ceil(totalregistros / 15) === 1){
                    this.getField("facturas").disabledButtons(true);
                }

                if (this.columna_modificada && this.filterTextLoweCase) {
                    this.getField("facturas").setRowData(data.data.data);
                }else{
                    this.gridOptionsTablafacturas["rowData"] = data.data.data;
                    this.getField('facturas').initData(this.gridOptionsTablafacturas, configCell);
                    this.getField('facturas').toggle(true);
                }
            } else {
                this.getField('facturas').toggle(false);
            }

        } else {
            if (this.columna_modificada && this.filterTextLoweCase) {
                this.getField('facturas').setRowData([]);
                this.getField('facturas').countPagination = 1;
                this.getField("facturas").disabledButtons(true);
                let totalregistros = 0;
                this.getField('facturas').setTtotalPg(Math.ceil(totalregistros / 15));
            }else{
                this.getField('facturas').toggle(false);
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    onBtNext2(){
        this.countTotal++;
        this.getField("facturas").disabledButtons(true);
        this.consultaFactura();
    }

    onBtPrevius2(){
        this.countTotal--;
        this.getField("facturas").disabledButtons(true);
        this.consultaFactura();
    }

    onKeyUpText(value){
        this.countTotal = value-1;
        this.getField("facturas").disabledButtons(true);
        this.consultaFactura();
    }

    crearBotones(props) {
        let fragment = document.createDocumentFragment();
        let btnExportarPdf = this.crearBotonTabla(props.data, 'Exportar PDF');
        btnExportarPdf.setAttribute("class", "buttonStyle2");
        fragment.appendChild(btnExportarPdf);
        return this.createElementJaivana(fragment);
    }

    /**
    * Establece la configuración del botón.
    * @param {La información que contiene el registro seleccionado} data 
    * @param {El botón seleccionado: Puede ser "Exportar PDF" ó otro que se renderice} boton 
    * @returns el botón con su respectiva configuración
    */
    crearBotonTabla(data, boton) {
        let button = document.createElement('input');
        switch (boton) {
            case 'Exportar PDF':
                button.setAttribute("id", `boton_exportar_pdf_${data.numero}`);
                break;
            default:
                break;
        }
        button.onclick = () => { this.accionBoton(data, boton) };
        button.setAttribute("value", boton);
        button.setAttribute("type", "button");
        return button;
    }

    accionBoton(data, boton) {
        if (boton === 'Exportar PDF') {
            this.getField('confirmModalCustom').setTitleAndContent('Exportar PDF', `¿Desea descargar PDF?`);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.datos = data;
                this.generarPdf();
                this.getField('confirmModalCustom').toggle(false);
            });
            this.getField("confirmModalCustom").setVisibleCancel(false); // "false" Para mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm(`${boton}`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }
        if (boton === 'Devolución') {
            this.getField('confirmModalCustom').setTitleAndContent('Devolución', `¿Desea hacer la devolución de esta remisión?`);
            this.getField('confirmModalCustom').setClickDialog(() => { 
                this.datos = data; 
                this.validarestado(data); 
            });
            this.getField("confirmModalCustom").setVisibleCancel(false); // "false" Para mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm(`${boton}`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }
    }

    //imprimir------->

    procesar(){
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S'){
            if(this.getField('email').valid()===false){
                errores++;
            }
        }
        
        if(errores===0){
            if(this.operacion_actual!==''){
                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreoTerceros();
                }else{
                    this.generarPdf();
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }
    
    validarestado(data){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{/*Se hace este setClickDialog para especificar que el click en este confirmModalCustom no hace nada, no tiene ninguna acción*/});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let datos={ datos: {
            numero: data.numero,
            codigo_sucursal: data.codigo_sucursal
        }};
        this.generalFormatPmv = { tipo_servicio: 'fact-listafacturas', operacion: 'validarestado', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successValidarEstado,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }
    
    successValidarEstado(data){
        this.getField('confirmModalCustom').toggle(false);
        this.consultaFactura();
        if(data.estado_p === 200){
            this.alertGeneral.toggle(true, 'Error esta remision ya ha sido facturada o anulada.', 'error');
        }else{
            this.TraerItems()
        }
    }
    
    TraerItems(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{/*Se hace este setClickDialog para especificar que el click en este confirmModalCustom no hace nada, no tiene ninguna acción*/});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let datos={ datos: {
            numero: this.datos.numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'fact-listafacturas', operacion: 'traer_items_factura', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successTraerItems,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }
     
    successTraerItems(data){
        this.getField('confirmModalCustom').toggle(false);
        this.consultaFactura();
        if(data.estado_p === 200){
            this.getField('modal_items').handleClickOpen();
            this.getField("items").toggle(true);
            this.gridOptionsTablaItems["rowData"] = data.data;
            this.datos_item = data.data;
            let configCell = new Map();
            configCell.set('cantidad_a_devolver', { cellRenderer: function (props) { return props.data.cantidad_a_devolver }, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, editable: true, onCellValueChanged: this.cantidadtablaChange, sortable: true, filter: false, field: 'cantidad_a_devolver' });
            configCell.set('subtotal1', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.subtotal1) }, cellStyle: {textAlign:"right"},width: 110});
            this.getField('items').initData(this.gridOptionsTablaItems,configCell);

            let count = data.data.length
            let cantidad = 0;

            for (let i = 0; i < this.datos_item.length; i++) {
                if(data.data[i].cantidad === data.data[i].cantidad_devuelta){
                    cantidad++
                }
            }

            if(cantidad === count){
                this.getField('guardar_devolucion').setDisabled(true);
            }else{
                this.getField('guardar_devolucion').setDisabled(false);
            }

        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    cantidadtablaChange(props) {
        //let seguir = this.getField('items').cellValid(props.oldValue, props.newValue, /^0*(?:[0-9][0-9]?|100000)$/);
        let seguir = this.getField('items').cellValid(props.oldValue, props.newValue, /^\d*$/);

        const cantidadRestante = props.data.cantidad - props.data.cantidad_devuelta;

        if (isNaN(props.data.cantidad_a_devolver) || seguir===false || props.newValue > cantidadRestante) {
            if(props.newValue > cantidadRestante){

                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `El valor debe ser menor o igual a `+cantidadRestante);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);

                props.data.cantidad_a_devolver = 0;

                // Actualizar datos internos en this.datos_item
                let index = this.datos_item.findIndex(x => x.codigo === props.data.codigo);
                if (index !== -1) {
                    this.datos_item[index] = props.data;
                }

                // Refrescar tabla
                this.getField("items").toggle(false);
                this.gridOptionsTablaItems["rowData"] = this.datos_item;
                //this.datos_item = this.datos_item;
                let configCell = new Map();
                configCell.set('cantidad_a_devolver', { cellRenderer: function (props) { return props.data.cantidad_a_devolver }, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, editable: true, onCellValueChanged: this.cantidadtablaChange, sortable: true, filter: false, field: 'cantidad_a_devolver' });
                configCell.set('subtotal1', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.subtotal1) }, cellStyle: {textAlign:"right"},width: 110});
                this.getField('items').initData(this.gridOptionsTablaItems,configCell);
                this.getField("items").toggle(true);
            }else{
                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `La columna cantidad_a_devolver no tiene un formato correspondiente al tipo (Numérico)`);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);
            }
        }else if(seguir){        

            props.data.cantidad_a_devolver = props.newValue;

            // Actualizar datos internos en this.datos_item
            let index = this.datos_item.findIndex(x => x.codigo === props.data.codigo);
            if (index !== -1) {
                this.datos_item[index] = props.data;
            }

            // Refrescar tabla
            this.getField("items").toggle(false);
            this.gridOptionsTablaItems["rowData"] = this.datos_item;
            //this.datos_item = this.datos_item;
            let configCell = new Map();
            configCell.set('cantidad_a_devolver', { cellRenderer: function (props) { return props.data.cantidad_a_devolver }, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, editable: true, onCellValueChanged: this.cantidadtablaChange, sortable: true, filter: false, field: 'cantidad_a_devolver' });
            configCell.set('subtotal1', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.subtotal1) }, cellStyle: {textAlign:"right"},width: 110});
            this.getField('items').initData(this.gridOptionsTablaItems,configCell);
            this.getField("items").toggle(true);

        }
    }

    GuardarDevolucion(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{/*Se hace este setClickDialog para especificar que el click en este confirmModalCustom no hace nada, no tiene ninguna acción*/});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

        let seguir = true;
        let cantidad = 0;
        for (let i = 0; i < this.datos_item.length; i++) {
            if(this.datos_item[i].cantidad_a_devolver > 0){
                cantidad++
            }
        }

        if(cantidad === 0){
            seguir = false;
            this.getField('confirmModalCustom').setTitleAndContent('Información', `Error al devolver remisión, no hay items para grabar`);
            this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
            this.getField('confirmModalCustom').toggle(true);
        }

        if(!this.getField('select_bodegas').valid()){
            seguir = false;
            this.getField('confirmModalCustom').toggle(false);
        }

        if(seguir){
            this.datos_item = this.datos_item.filter(item => {
                const cantidad = Number(item.cantidad_a_devolver ?? 0);
                return cantidad > 0;
            });

            let datos={ datos: {
                numero: this.datos.numero,
                codigo_sucursal: this.datos.codigo_sucursal,
                codigo_bodega:this.getField('select_bodegas').getValue(),
                productos: JSON.stringify(this.datos_item),
            }};
            this.generalFormatPmv = { tipo_servicio: 'fact-listafacturas', operacion: 'grabar_devolucion', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successGrabarDevolucion,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    successGrabarDevolucion(data){
        if(data.estado_p === 200){
            let url = this.constant.formConfiguration();
            let datos2= {
                nit: this.datos.nit,
                sede: this.datos.sede,
                fecha: data.data.fecha,
                consecutivo: data.data.numero,
                factura: data.data.numero,
                sucursal_ingreso: this.datos.codigo_sucursal,
                codigo_facturacion:this.datos.codigo_facturacion,
                email:'.',
                operacion: 'pdf'
            };
            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"most-caja","operacion":"imprimirfactura","operacion_tipo":"consulta"}}';
            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            if(response.status!==200){
            return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                            this.getField('confirmModalCustom').toggle(false);
                        }else{
                            const pdf = new File([blob], 'RM_'+this.datos.numero+'.pdf', {
                                type:'application/pdf'});
                            window.open(URL.createObjectURL(pdf));
                            this.getField('confirmModalCustom').toggle(false);
                        } 
                        this.getField('modal_items').handleClose();
                        this.getField("items").toggle(false);
                        this.gridOptionsTablaItems["rowData"] = [];
                        this.datos_item = [];
                        
                        this.alertGeneral.toggle(true, 'Se grabó con exito. Numero: '+data.data.numero, 'success');
                    });
                }else{
                    this.getField('confirmModalCustom').toggle(false);
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.getField('confirmModalCustom').toggle(false);
                this.alertGeneral.toggle(true,err,'error');
            });
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    generarPdf()
    {       
      this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
      this.getField('confirmModalCustom').setClickDialog(()=>{/*Se hace este setClickDialog para especificar que el click en este confirmModalCustom no hace nada, no tiene ninguna acción*/});  
      this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
      this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
      this.getField('confirmModalCustom').toggle(true);
        let url = this.constant.formConfiguration();
        let datos2= {
            nit: this.datos.nit,
            sede: this.datos.sede,
            fecha: this.datos.fecha,
            email:'.',
            consecutivo: this.datos.numero,
            factura: this.datos.numero,
            sucursal_ingreso: this.datos.codigo_sucursal,
            codigo_facturacion:this.datos.codigo_facturacion,
            operacion: 'pdf'
        };
        const myJSON = JSON.stringify(datos2);
        let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"most-caja","operacion":"imprimirfactura","operacion_tipo":"consulta"}}';
        fetch(url+datos,{
        method:'GET', 
        headers:new Headers({
                "Authorization": 'Bearer '+localStorage.getItem('token'), 
                "Content-Type":'application/json'})})
        .then(response => {
        if(response.status!==200){
        return '';
        }
        const reader = response.body.getReader();
        return new ReadableStream({
        start(controller) {
        return pump();
        function pump() {
                return reader.read().then(({ done, value }) => {
                if (done) {
                    controller.close();
                    return;}
                controller.enqueue(value);
                return pump();});}}})})
        .then(stream => new Response(stream))
        .then(response => response.blob())
        .then(blob => {
            if(blob.size>0){
                blob.text().then(res=>{
                    if(this.isJson(res)){
                        this.successEnviarCorreo(JSON.parse(res));
                        this.getField('confirmModalCustom').toggle(false);
                    }else{
                        const pdf = new File([blob], 'RM_'+this.datos.numero+'.pdf', {
                            type:'application/pdf'});
                        window.open(URL.createObjectURL(pdf));
                        this.getField('confirmModalCustom').toggle(false);
                    } 
                });
            }else{
                this.getField('confirmModalCustom').toggle(false);
                this.mostrarMensajeNoHayDatos();
            }
        }).catch(err => {
            this.getField('confirmModalCustom').toggle(false);
            this.alertGeneral.toggle(true,err,'error');
        });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    mostrarMensajeEmailEnviado(){
    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo(){
    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
    }
    
    mostrarMensajeNoHayDatos(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    validarNit(data){
        if(data.length === 1){
            this.sedes = 1; 
        }if(data.length > 1){
            this.sedes=data.length;
        }
   }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>2){
              decimal=(Number(number).toFixed(2) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number) {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    traerDatosBodegas(){
        //this.mostrarMensajeGenerando();
        let datos={ datos: {  }};
        this.generalFormatPmv = { tipo_servicio: 'maes-bodegas', operacion: '1_activas', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerDatosBodegas,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }


    successTraerDatosBodegas(data){
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200)
        {

            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.codigo_bodega;
                dataOp['text'] = item.codigo_bodega+'-'+item.nombre;
                dataOp['campos_cambian'] = {};
                opciones.push(dataOp);
            });
            
        }else 
        {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
        this.getField('select_bodegas').setOptions(opciones);
        this.getField('select_bodegas').setError(false,'');
    }

}
FormJaivana.addController("fact-listafacturas", CustomListaFacturas);
export default CustomListaFacturas;